import React from "react";
import { NotificationType } from "../assets/types";
import { IconButton } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useBoundStore } from "store/store";

const StatusCard = (props: any) => {

  let lang:any = useBoundStore(state => state.lang);

  return (
    <>
      {props.type !== 1 && ["0", "6", "7","2"].includes(props?.type) ? (
        <div onClick={() => props.onPressCard(props.type)} style={{ display:"flex",alignItems:"center",margin: props.selected ? "5px" : "10px",cursor:"pointer"}}>
          {["0", "6", "7","2"].includes(props?.type) && (
            <div className="text">
              <span>
                {NotificationType(props?.type, lang, props?.count > 1)}{" "}
                {props?.count > 0 ? props?.count : ""}
              </span>
            </div>
          ) }

          {props.selected && (
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => props.onPressXIcon(props.type)}
            >
              {" "}
              <CancelIcon fontSize="small"/>
            </IconButton>
          )}
        </div>
      ) : null}
    </>
  );
};

export default StatusCard;
